export default __webpack_public_path__ + "static/media/Алтай.da9b5c1a.svg";